import AdminRouteSelector, { AdminRoute } from "@app/components/admin-route-selector.tsx";
import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const routes: AdminRoute[] = [
    { to: "/admin/other/client-categories", name: "Client Categories" },
    { to: "/admin/other/state-codes", name: "State Codes" },
    { to: "/admin/other/system-info", name: "System Information" },
];

export const Route = createFileRoute("/_authenticated/_admin/admin/other")({
    component: Component,
});

function Component() {
    return (
        <>
            <AdminRouteSelector routes={routes} />
            <Box width={"100%"} mt={2}>
                <Outlet />
            </Box>
        </>
    );
}
